import React from 'react';

import styled from '@emotion/styled';
import { Tooltip, tooltipClasses } from '@mui/material';

import { ObjectAny } from '@/models/types';

import type { TooltipProps } from './Tooltip';

export const StyledTooltip = styled(
    ({ className, tooltipBackground: _b, tooltipColor: _c, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ),
)(({ tooltipBackground, tooltipColor }) => {
    const styles: ObjectAny = {};

    if (tooltipBackground) {
        styles[`& .${tooltipClasses.arrow}`] = { color: tooltipBackground };
        styles[`& .${tooltipClasses.tooltip}`] = { backgroundColor: tooltipBackground };
    }

    if (tooltipColor) {
        styles[`& .${tooltipClasses.tooltip}`] = {
            ...styles[`& .${tooltipClasses.tooltip}`],
            color: tooltipColor,
        };
    }

    return styles;
});
